import { render, staticRenderFns } from "./BusDetail.vue?vue&type=template&id=3ecf857d&scoped=true&"
import script from "./BusDetail.vue?vue&type=script&lang=js&"
export * from "./BusDetail.vue?vue&type=script&lang=js&"
import style0 from "./BusDetail.vue?vue&type=style&index=0&id=3ecf857d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecf857d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VCol,VRow})
